import React from "react";
import Layout from "src/components/Layout";
import ApplicationSection from "src/components/ApplicationSection";
function Application() {
  return (
    <Layout hideFooter hideSocialIcons>
      <ApplicationSection></ApplicationSection>
    </Layout>
  );
}

export default Application;
